import { connect } from 'react-redux'
import requestChangeCardStatus from '../../sagas/requestChangeCardStatus'
import statusSelector from './statusSelector'
import Status from './Status'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  statusSelector,
  {
    requestChangeCardStatus
  }
)(Status))
